export const textAndImageContainerColumnGap = {
  smallDesktop: '50px',
  largeDesktop: '150px',
};
